import CallWaiters from "./apiCallWaiters";
import Prepare from "./apiPrepare";
import Xendit from "./apiXendit";

const api = {
  apiPrepare: new Prepare(),
  apiXendit: new Xendit(),
  apiCallWaiters: new CallWaiters(),
};

export default api;
